import $ from 'jquery';
import axios from 'axios';
import gtmUtils from './formGtmUtils';

export const init = () => {
	const pushDataLayer = (event, data) => {
		dataLayer.push({
			event: event,
			formData: { ...data }, // Push copy of data, so already pushed objects wont be affected.
		});
	};

	let formStart = (data) => {
		pushDataLayer('formStart', data);
		formStart = () => {};
	};

	const formUpdate = (data, formWrapperID) => {
		gtmUtils.radioDeselectListener(formWrapperID);
		const $inputs = formWrapperID !== '' ? $(`div[id*="${formWrapperID}"] .form-field :input`) : $('.form-field :input');
		$inputs.each(function () {
			const id = $(this).attr('id');
			const name = $(this).attr('name');
			if (id !== undefined) {
				$(this).attr('dL-value', '');
				$(this).on('change', function () {
					// Ensure value was really changed.
					if ($(this).attr('type') === 'checkbox' || $(this).attr('dL-value') !== $(this).val()) {
						data['leadProductType'] = gtmUtils.getLeadProductType(formWrapperID);
						data['formFields'] = gtmUtils.fillFormFields(formWrapperID);
						formStart(data);
						data['updatedFormFields'] = gtmUtils.getUpdatedFormField(id, name);
						data = gtmUtils.addFunnelIDs(data);
						pushDataLayer('formUpdate', data);
					}
					if ($(this).attr('type') !== 'checkbox') {
						$(this).attr('dL-value', $(this).val());
					}
				});
			}
		});
	};

	const formSubmitSuccess = (data, formWrapperClass = '') => {
		if (formWrapperClass !== '') {
			data['leadProductType'] = gtmUtils.getLeadProductTypeByWrapperClass(formWrapperClass, data['leadProductType']);
			data['formFields'] = gtmUtils.fillFormFieldsByWrapperClass(formWrapperClass);
		} else {
			data['leadProductType'] = gtmUtils.getLeadProductTypeThankYouPage(data['leadProductType']);
		}
		data = gtmUtils.addFunnelIDs(data);
		pushDataLayer('formSubmitSuccess', data);
	};

	const formError = (data, formWrapperID = '') => {
		data['leadProductType'] = gtmUtils.getLeadProductType(formWrapperID);
		data['formFields'] = gtmUtils.fillFormFields(formWrapperID);
		let errors = {};
		errors['formFieldErrors'] = gtmUtils.getErrors();
		errors['errorMessage'] = '';

		// copy errors from errorMessage.
		errors['formFieldErrors'].forEach(function (item) {
			const keyVal = Object.entries(item)[0];
			if (keyVal) {
				errors['errorMessage'] += `${keyVal[0]}: ${keyVal[1]} `;
			}
		});
		data = gtmUtils.addFunnelIDs(data);
		pushDataLayer('formError', { ...data, ...errors });
	};

	const retenceFormError = (data, wrapperClass) => {
		data['formFields'] = gtmUtils.fillFormFieldsByWrapperClass(wrapperClass);
		let errors = {};
		errors['formFieldErrors'] = gtmUtils.getErrors();
		errors['errorMessage'] = $('.validation-errors').text();
		if (errors['formFieldErrors'].length > 0 || errors['errorMessage']) {
			if (!errors['errorMessage']) {
				// copy errors from errorMessage.
				errors['formFieldErrors'].forEach(function (item) {
					let keyVal = Object.entries(item)[0];
					if (keyVal) {
						errors['errorMessage'] += `${keyVal[0]}: ${keyVal[1]} `;
					}
				});
			}
			data = gtmUtils.addFunnelIDs(data);
			pushDataLayer('formError', { ...data, ...errors });
		}
	};

	const retenceFormErrorFE = (data, wrapperClass) => {
		setTimeout(function () {
			retenceFormError(data, wrapperClass);
		}, 500);
	};

	const formLoad = (data, formWrapperID) => {
		data['leadProductType'] = gtmUtils.getLeadProductType(formWrapperID);
		data['formFields'] = gtmUtils.fillFormFields(formWrapperID);
		data = gtmUtils.addFunnelIDs(data);
		pushDataLayer('formLoad', data);
	};

	const formStepNext = (data, wrapperClass) => {
		data['formFields'] = gtmUtils.fillFormFieldsByWrapperClass(wrapperClass);
		let source = gtmUtils.getLeadProductTypeByWrapperClass(wrapperClass, data['leadProductType']);
		if (source != data['leadProductType']) {
			data['leadProductType'] = gtmUtils.getSource(source);
		}
		data = gtmUtils.addFunnelIDs(data);
		pushDataLayer('formStepNext', data);
	};

	const formStepPrevious = (data, wrapperClass) => {
		data['formFields'] = gtmUtils.fillFormFieldsByWrapperClass(wrapperClass);
		data = gtmUtils.addFunnelIDs(data);
		pushDataLayer('formStepPrevious', data);
	};

	const retenceFieldUpdate = (data, wrapperClass, key) => {
		data['formFields'] = gtmUtils.fillFormFieldsByWrapperClass(wrapperClass);
		formStart(data);

		let source = gtmUtils.getLeadProductTypeByWrapperClass(wrapperClass, data['leadProductType']);
		if (source != data['leadProductType']) {
			data['leadProductType'] = gtmUtils.getSource(source);
		}
		data['updatedFormFields'] = [key];
		data = gtmUtils.addFunnelIDs(data);
		pushDataLayer('formUpdate', data);
	};

	const retenceFormLoad = (data, wrapperClass) => {
		data['formFields'] = gtmUtils.fillFormFieldsByWrapperClass(wrapperClass);
		data = gtmUtils.addFunnelIDs(data);
		pushDataLayer('formLoad', data);
	};

	const retenceFormUpdateField = (key) => {
		if (document.readyState === 'complete') {
			retenceFieldUpdate(data, 'retence-forms', key);
		}
	};

	const formSubmitCta = (data) => {
		data['event'] = 'ctaClick';
		data['ctaPosition'] = 'form';
		try {
			dataLayer.push(data);
		} catch {}
	};

	const initFormSubmitRedirect = () => {
		const params = window.location.search.substring(1).split('&');
		const prefix = 'DLFORM';
		const paramsDict = {};
		let newParams = window.location.search.substring(1);

		params.forEach(function (item) {
			if (item.startsWith(prefix)) {
				const keyVal = item.replace(prefix, '').split('=');
				paramsDict[keyVal[0]] = keyVal[1];
				newParams = newParams.replace(item + '&', '');
				newParams = newParams.replace(item, '');
			}
		});

		if ('FormID' in paramsDict && 'ItemID' in paramsDict && 'FieldPrefix' in paramsDict) {
			let url = `/api/datalayers/formitem/${paramsDict['FormID']}/${paramsDict['ItemID']}/${paramsDict['FieldPrefix']}?`;

			if (paramsDict.eonFormID) {
				url += `eonFormID=${paramsDict['eonFormID']}&`;
			}
			url = gtmUtils.addQueryParam(url, paramsDict, 'transactionID');
			url = gtmUtils.addQueryParam(url, paramsDict, 'funnelID');
			url = gtmUtils.addQueryParam(url, paramsDict, 'cmsID');
			url = gtmUtils.addQueryParam(url, paramsDict, 'leadProduct');

			url = url.slice(0, -1);

			axios.get(url).then((response) => {
				if (Object.keys(response.data).length > 0) {
					pushDataLayer('formSubmitSuccess', response.data);
				}
			});

			// Remove parameters so dL is not sent again.
			if (newParams) {
				if (newParams.endsWith('&') || newParams.endsWith('?')) {
					newParams = newParams.substring(0, newParams.length - 1);
				}
				window.history.replaceState(null, null, window.location.pathname + '?' + newParams + window.location.hash);
			} else {
				window.history.replaceState(null, null, window.location.pathname + window.location.hash);
			}
		}
	};

	const initRetenceFormSubmitRedirect = () => {
		const params = window.location.search.substring(1).split('&');
		const prefix = 'DLRETENCEFORM';
		const paramsDict = {};
		let newParams = window.location.search.substring(1);

		params.forEach(function (item) {
			if (item.startsWith(prefix)) {
				const keyVal = item.replace(prefix, '').split('=');
				paramsDict[keyVal[0]] = keyVal[1];
				newParams = newParams.replace(item + '&', '');
				newParams = newParams.replace(item, '');
			}
		});
		if ('FormID' in paramsDict && 'LeadProductType' in paramsDict) {
			let url = `/api/datalayers/retenceformitem/${paramsDict['FormID']}/${paramsDict['LeadProductType']}?`;

			url = gtmUtils.addQueryParam(url, paramsDict, 'transactionID');
			url = gtmUtils.addQueryParam(url, paramsDict, 'funnelID');
			url = gtmUtils.addQueryParam(url, paramsDict, 'cmsID');
			url = gtmUtils.addQueryParam(url, paramsDict, 'leadProduct');

			url = url.slice(0, -1);
			axios.get(url).then((response) => {
				if (Object.keys(response.data).length > 0) {
					pushDataLayer('formSubmitSuccess', response.data);
				}
			});

			// Remove parameters so dL is not sent again.
			if (newParams) {
				if (newParams.endsWith('&') || newParams.endsWith('?')) {
					newParams = newParams.substring(0, newParams.length - 1);
				}
				window.history.replaceState(null, null, window.location.pathname + '?' + newParams + window.location.hash);
			} else {
				window.history.replaceState(null, null, window.location.pathname + window.location.hash);
			}
		}
	};

	window.gtm = {
		formLoad,
		formStart,
		formUpdate,
		formStepNext,
		formStepPrevious,
		formSubmitSuccess,
		formError,
		retenceFormError,
		retenceFormErrorFE,
		retenceFieldUpdate,
		retenceFormLoad,
		retenceFormUpdateField,
		formSubmitCta,
	};

	initFormSubmitRedirect();
	initRetenceFormSubmitRedirect();
};
